module.exports = __webpack_public_path__ + "img/zapier_logo.58a41dfe.png";